import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { onboardingKeys } from "@/lib/query-keys";
import type { ContractorPreview } from "@/types/domain";

/**
 * Licitaciones convocadas de su objeto que calzan con lo que hace quien le vende
 * al Estado: el mismo universo que mostrará su línea. Con `details` trae las 5
 * primeras. Si falla, la pantalla sigue sin números.
 */
export function useContractorPreview({
  subjects,
  terms,
  departmentIds,
  amountMin = null,
  amountMax = null,
  details = false,
  enabled = true,
}: {
  subjects: string[];
  terms: string[];
  departmentIds: number[];
  amountMin?: number | null;
  amountMax?: number | null;
  details?: boolean;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: onboardingKeys.contractorPreview(
      subjects,
      terms,
      departmentIds,
      amountMin,
      amountMax,
      details,
    ),
    enabled: enabled && terms.length > 0,
    placeholderData: keepPreviousData,
    retry: false,
    queryFn: () => {
      const params = new URLSearchParams({
        subjects: subjects.join(","),
        terms: terms.join(","),
        departmentIds: departmentIds.join(","),
        details: String(details),
        ...(amountMin != null ? { amountMin: String(amountMin) } : {}),
        ...(amountMax != null ? { amountMax: String(amountMax) } : {}),
      });
      return fetchToBackend<ContractorPreview>(
        `/onboarding/contractor-preview?${params}`,
      );
    },
  });
}
